<template>
	<div class="columns is-desktop">
		<aside class="column is-one-third">
			<nav class="menu pt-5" aria-label="Filter openings">
				<FilterList taxonomy="departments" label="Department" />
				<FilterList taxonomy="locations" label="Location" class="mt-5" />
				<FilterList taxonomy="workplaceTypes" label="Contract type" class="mt-5" />
			</nav>
		</aside>

		<main class="column">
			<template v-if="groupedPostings.length > 0">
				<template v-for="team in groupedPostings" :key="team.title">
					<article class="py-5">
						<h2 class="title is-2">{{ team.title }}</h2>

						<ul class="posting-list">
							<Posting
								v-for="posting in team.postings"
								:key="posting.id"
								:posting="posting"
							/>
						</ul>
					</article>

					<hr />
				</template>
			</template>
			<div v-else-if="$store.ready" class="notification has-text-centered">
				<p>
					Sorry, no openings match your filters.
					Join our
					<a
						:href="talentCommunityUrl"
						target="_blank"
						rel="noopener"
						@click="trackTalentCommunity"
					>talent community</a>
					to be the first to be notified of future opportunities.
				</p>
			</div>
		</main>
	</div>
</template>

<script>

import analytics from 'Scripts/analytics';

import FilterList from './FilterList.vue';
import Posting from './Posting.vue';

import { getFilteredPostings, groupPostingsByDepartment } from '../helpers/postings.js';

export default {
	props: {
		talentCommunityUrl: {
			type: String,
			required: true,
		},
	},

	computed: {
		/* Openings matching the current department, location, and contract type selections */
		filteredPostings() {
			return getFilteredPostings(
				this.$store.postings,
				this.$store.filter.departments,
				this.$store.filter.locations,
				this.$store.filter.workplaceTypes,
			);
		},

		/* Filtered openings grouped into department sections for the current list layout */
		groupedPostings() {
			return groupPostingsByDepartment(this.filteredPostings);
		},
	},

	methods: {
		/* Same CTA event as the openings page talent-community tailer */
		trackTalentCommunity() {
			analytics.trackAnalyticsEvent('cta', 'click', 'careers-talent-community-cta');
		},
	},

	components: {
		FilterList,
		Posting,
	},
};

</script>
